/**
 * Created by ws7 on 2017/6/12.
 */

import * as snapConst from './constants';


export default {
    [snapConst.getSnaps](state, snapSet) {
        state.list = snapSet.LocalVolumeSnapshotSet || [];
        state.total = snapSet.LocalVolumeSnapshotCount
    },
    [snapConst.getDataDiskSnaps](state, snapSet) {
        // state.list = snapSet.LocalVolumeSnapshotSet;
        // state.total = snapSet.LocalVolumeSnapshotCount
    },
    [snapConst.DescribeSnapshots](state, snapSet) {
        state.SnapshotsList = snapSet.Snapshots;
    }
};
